/**
 * Formats a number as a euro amount with two decimal places.
 * @param amount - The amount to format
 * @returns The formatted amount (e.g., "10.00 €")
 */
export const formatPercentage = (amount: number): string => {
  const isIntegerAmount = Number.isInteger(amount);
  const formattedAmount = isIntegerAmount
    ? amount.toLocaleString("fr-FR")
    : amount.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${formattedAmount} %`;
};
